import PropTypes from 'prop-types';
import { ApolloError } from 'apollo-client';

export const videoShape = PropTypes.shape({
  etag: PropTypes.string,
  kind: PropTypes.string,
  id: PropTypes.shape({
    kind: PropTypes.string,
    videoId: PropTypes.string
  }),
  snippet: PropTypes.shape({
    channelId: PropTypes.string,
    channelTitle: PropTypes.string,
    description: PropTypes.string,
    liveBroadcastContent: PropTypes.string,
    publishedAt: PropTypes.string,
    title: PropTypes.string,
    thumbnails: PropTypes.shape({
      default: PropTypes.shape({
        height: PropTypes.number,
        url: PropTypes.string,
        width: PropTypes.number
      }),
      high: PropTypes.shape({
        height: PropTypes.number,
        url: PropTypes.string,
        width: PropTypes.number
      }),
      medium: PropTypes.shape({
        height: PropTypes.number,
        url: PropTypes.string,
        width: PropTypes.number
      })
    })
  })
});

export const userShape = PropTypes.shape({
  userId: PropTypes.string,
  displayName: PropTypes.string,
  username: PropTypes.string,
  email: PropTypes.string,
  isAdmin: PropTypes.bool,
  avatarUrl: PropTypes.string
});

export const wallCommentShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  comment: PropTypes.string,
  created: PropTypes.string,
  user: userShape
});

export const wallPostShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  user: userShape,
  message: PropTypes.string,
  created: PropTypes.string,
  isPinned: PropTypes.bool,
  comments: PropTypes.shape({
    comments: PropTypes.arrayOf(wallCommentShape)
  })
});

export const communityMessageShape = PropTypes.shape({
  id: PropTypes.number,
  start: PropTypes.string,
  end: PropTypes.string,
  durationSec: PropTypes.number,
  message: PropTypes.string,
  properties: PropTypes.object
});

export const chatMessageShape = PropTypes.shape({
  id: PropTypes.number,
  room: PropTypes.string,
  message: PropTypes.string,
  created: PropTypes.string,
  author: userShape
});

export const gameShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  displayName: PropTypes.string,
  description: PropTypes.string,
  isMobileFriendly: PropTypes.bool
});

export const tournamentShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  created: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  status: PropTypes.string,
  startChips: PropTypes.number,
  category: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  }),
  terms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string
    })
  ),
  game: gameShape
});

export const tournamentsShape = PropTypes.shape({
  tournaments: PropTypes.arrayOf(tournamentShape)
});

export const patronStatusShape = PropTypes.shape({
  playerid: PropTypes.string,
  activeClubID: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  freePlay: PropTypes.number,
  shoppingDollars: PropTypes.number,
  basePoints: PropTypes.number,
  clubState: PropTypes.string,
  extClubState: PropTypes.string,
  pointsNeeded: PropTypes.number,
  basePointsEarned: PropTypes.number
});

export const errorShape = PropTypes.oneOfType([
  PropTypes.instanceOf(Error),
  PropTypes.instanceOf(ApolloError)
]);



// WEBPACK FOOTER //
// ./src/utils/shapes.js